export enum ResearchModelRefId {
  RESEARCH_BOARD = 'model:5'
}
